module.exports = __webpack_public_path__ + "static/media/top-anime.0b7c1d65.jpg";